import React, { PropTypes } from 'react';

import Filter from '../Filter';

import { NitroIcon } from 'nitro-components';

import styled from 'styled-components';

const NumberInputContainer = styled.div`
  display: inline-block;
`;

const NumberInput = styled.section`
  display: flex;
`;

const NumberInputButton = styled.span`
  display: flex;
  width: 32px;
  line-height: 32px;
  justify-content: center;
  align-items: center;
  background: ${props => props.theme.color.secondary};
  cursor: pointer;
`;

const SpinerInput = styled.input`
  text-align: center;
  margin: 0 4px;
  max-width: 50px;
  color: ${props => props.theme.color.secondary};
  &:focus {
    outline: none;
  }
`;

const NumberSpinner = ({ filter, action }) => {
  const handleInputChange = e => {
    const value = e.target.value > 1 ? e.target.value : 1;
    const parsedValue = parseInt(value, 10);
    action({
      value: parsedValue,
      label: parsedValue
    });
  };

  const decrementValue = value => {
    if (value > 1) {
      value--;
      action({
        value,
        label: value
      });
    }
  };

  const incrementValue = value => {
    value++;
    action({
      value,
      label: value
    });
  };

  const value = filter.value || 1;

  return (
    <NumberInputContainer>
      <NumberInput>
        <NumberInputButton
          id="number-input-decrement"
          onClick={() => decrementValue(value)}
        >
          <NitroIcon name="minus" size={12} variant="white" />
        </NumberInputButton>
        <SpinerInput value={value} onChange={handleInputChange} type="text" />
        <NumberInputButton
          id="number-input-increment"
          onClick={() => incrementValue(value)}
        >
          <NitroIcon name="add" size={12} variant="white" />
        </NumberInputButton>
      </NumberInput>
    </NumberInputContainer>
  );
};

NumberSpinner.propTypes = {
  action: PropTypes.func,
  filter: PropTypes.object.isRequired
};

NumberSpinner.getLabel = Filter.getLabel;

export default NumberSpinner;



// WEBPACK FOOTER //
// ./src/components/filter/filters/number-spinner/NumberSpinner.js